import React from 'react';
import Temp from './components/onlineMembers/members';

const App = () => {
  return (
    <Temp/>
  )
}

export default App